<template>
    <div v-if="visible" class="field-selection-wrapper explanation-selection-wrapper" :style="{'border-color': colors.highlightColor}">
        <div class="question-title">
            <question-title :color="colors.baseColor" :title="field.title" :required="field.required"></question-title>
        </div>
        <question-description :color="colors.secondaryColor" :description="field.description"></question-description>
    </div>
</template>

<script>
    import Field from './Field'

    export default {
        name: 'TextField',
        extends: Field,
        props: ['field', 'colors'],
        data() {
            return {}
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// node_modules/survey-fields/src/Question/Fields/ExplanationField.vue